<div class="overflow-y-auto h-full">
  <iframe
    [src]="url | safe" width="100%" height="100%">
  </iframe>
</div>
